import { render, staticRenderFns } from "./signature_badge.vue?vue&type=template&id=6feabdb2"
import script from "./signature_badge.vue?vue&type=script&lang=js"
export * from "./signature_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports